import React from 'react'
import type { FC } from 'react'
interface Props {
  className?: string;
  color?: string;
  size?: number | string;
  rotateOnRtl?: boolean;
}
export const IconAirConditioner: FC<Props> = ({
  color = 'currentColor',
  size = 24,
  className,
  rotateOnRtl = false,
  ...rest
}) => {
  const props = {
    width: size,
    height: size,
    fill: color,
    // stroke: color,
    className,
    viewBox: '0 0 24 24',
    ['data-rotateonrtl']: false,
    ...rest,
  }
  return /*#__PURE__*/ React.createElement(
    'svg',
    Object.assign(
      {
        xmlns: 'http://www.w3.org/2000/svg',
        width: 24,
        height: 24,
        viewBox: '0 0 24 24',
      },
      props
    ),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M21 11h-3.6l2.3-2.3c.4-.4.4-1 0-1.4-.4-.4-1-.4-1.4 0L14.6 11H13V9.4l3.7-3.7c.4-.4.4-1 0-1.4-.4-.4-1-.4-1.4 0L13 6.6V3c0-.6-.4-1-1-1s-1 .4-1 1v3.6L8.7 4.3c-.4-.4-1-.4-1.4 0-.4.4-.4 1 0 1.4L11 9.4V11H9.4L5.7 7.3c-.4-.4-1-.4-1.4 0-.4.4-.4 1 0 1.4L6.6 11H3c-.6 0-1 .4-1 1s.4 1 1 1h3.6l-2.3 2.3c-.4.4-.4 1 0 1.4.2.2.4.3.7.3.3 0 .5-.1.7-.3L9.4 13H11v1.6l-3.7 3.7c-.4.4-.4 1 0 1.4.4.4 1 .4 1.4 0l2.3-2.3V21c0 .6.4 1 1 1s1-.4 1-1v-3.6l2.3 2.3c.2.2.5.3.7.3.2 0 .5-.1.7-.3.4-.4.4-1 0-1.4L13 14.6V13h1.6l3.7 3.7c.2.2.5.3.7.3.2 0 .5-.1.7-.3.4-.4.4-1 0-1.4L17.4 13H21c.6 0 1-.4 1-1s-.4-1-1-1z',
    })
  )
}
